import Image from "next/image"
import Link from "next/link"

const NoLeaders = () => {
    return (
        <div className="flex flex-col items-center gap-4 my-16">
            <Image
                src="/assets/img/icons/empty.svg"
                alt="No Leaders"
                width={128}
                height={128}
                className="w-56 h-56 mx-auto"
            />

            <h6 className="mt-4 text-lg font-semibold text-gray-600">
                There are no leaders for this category.
            </h6>

            <p className="mt-2 text-sm font-semibold text-gray-600">
                Be the first to be showcased as a leader for this category.
            </p>

            <div className="flex items-center justify-center gap-8 my-4">
                <Link
                    href="/sign-up"
                    className="flex items-center justify-center gap-2 px-8 py-4 text-sm font-medium text-white rounded-lg w-max bg-brand-primary"
                >
                    Sign Up Now
                </Link>
            </div>
        </div>
    )
}

export default NoLeaders
